// Bookings are for times to come (Oct 2026 sweep). A slot that has gone is greyed out on the
// grid and in the form's times: someone who is here now is a walk-in, seated from Tables,
// which is how booking systems at the host stand work. A booking already made can still be
// opened and changed after its time, for its notes or covers.
import { toMinutes } from './bookingQueue';

// The slot that contains now is still open: 19:04 can still book 19:00.
const GRACE_MIN = 10;

/** Has `time` on `date` gone, against the venue's `today` and `nowMinutes`? */
export function isPastSlot(date, time, today, nowMinutes) {
  if (!date || !today) return false;
  if (date < today) return true;
  if (date > today || !time || nowMinutes == null) return false;
  return toMinutes(time) + GRACE_MIN <= nowMinutes;
}

/** The first slot in `slots` that hasn't gone, or null. */
export function firstOpenSlot(slots, date, today, nowMinutes) {
  return slots.find((s) => !isPastSlot(date, s, today, nowMinutes)) || null;
}
